﻿/* 
Object:         Addressbook
Description:    Logic and events for the module Addressbook
Used in:        Addressbook
*/

window.addressbook = function () {

    return {

        /**
         * Init (binding button actions) Overview grid
         */
        initialize: function () {

            // Create new record ...
            $(".k-grid-add").click(function (e) {

                // Prevent default behaviour 
                e.preventDefault();

                // Load create form into the current module div
                navigation.navigateToSpecificUrl("Addressbook/Add");
            });

        },

        /**
         * Delete item from grid
         * @param {any} e
         */
        deleteItem: function (e) {
            var event = e;
            var data = this;

            function callbackYes(event, data) {

                // Prevent default behaviour 
                event.preventDefault();

                var dataItem = data.dataItem($(event.currentTarget).closest("tr"));

            // Post Data
            $.ajax({
                type: "GET",
                url: appsettings.getUrl("Addressbook/Delete?addressId=" + dataItem.AddressID),
                success: function (responseData) {

                        // Refresh datasource grid 
                        $("#AddressbookGrid").data("kendoGrid").dataSource.read();

                    }
                });
            }

            function callingCallback() {
                callbackYes(event, data);
            }

            dialog.createDialog(callingCallback, function () { });
        },

        /**
         * Update a item from grid
         * @param {any} e
         */
        editItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            // Get DateItem
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Label
            var label = dataItem.Name;

            // Edit mode Form 
            viewmode.setViewMode(ModuleActionViewEnum.Edit);

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("Addressbook/Edit?addressId=" + dataItem.AddressID + "&breadcrumbLabel=" + label);
        },

        /**
         * Show item from grid
         * @param {any} e
         */
        showItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            // Get DateItem 
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Label
            var label = dataItem.Name;

            // Show mode Form
            viewmode.setViewMode(ModuleActionViewEnum.Show);

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("Addressbook/Show?addressId=" + dataItem.AddressID + "&breadcrumbLabel=" + label);
        }
    }
}();